import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94be6bf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { id: "play3D" }
const _hoisted_3 = { class: "slider" }
const _hoisted_4 = { class: "switch" }

import qs from 'qs';
import moment from 'moment';
import { useStore, } from 'vuex';
import { Slider, Switch, } from 'ant-design-vue';
import {
  ref, withDefaults, watch, computed, onBeforeUnmount, createVNode, onMounted,
} from 'vue';
import { timeConvert, } from '@/utils';

import SideBar from '../sidebar/index.vue';
import Popup from '../../../Map2D/components/environmentPopUp/index.vue';
import weatherPopUp from '../../../Map2D/components/weatherPopUp/index.vue';
import { Item, } from 'ant-design-vue/lib/menu';

interface Props {
  cesiumViewer: any,
}

export default /*#__PURE__*/_defineComponent({
  props: {
    cesiumViewer: { default: Object }
  },
  setup(__props: any) {

const props = __props as { cesiumViewer: any }



const store = useStore();

// 要素对应文字
const factorKey = {
  AOD: 'AOD',
  PM25: '<span>PM<sub>2.5</sub></span>',
  PM10: '<span>PM<sub>10</sub></span>',
  SO2: '<span>SO<sub>2</sub></span>',
  NO2: '<span>NO<sub>2</sub></span>',
  CO: 'CO',
  O3: '<span>O<sub>3</sub></span>',
  AQI: 'AQI',
  RADAR: '雷达',
  TEM: '气温',
  PRS: '气压',
  RHU: '湿度',
  PRE: '降水',
};
// 设置播放轴显隐
const playShow = ref(true);

// 站点展示
const pointCheckedShow = ref(true);

// 设置播放轴时间刻度
const type = computed(() => store.state.layerConsole.type);

// 站点显隐
const pointChecked = ref<boolean>(true);

// 时间集合
const playTime = computed(() => store.state.layerConsole.playTime);
const playMin = ref(0);
const playMax = ref(0);
const marks = ref({});
// 当前播放下标
const current = ref(0);
// 播放轴播放逻辑

// 是否播放
const isPlay = ref(false);
// 计时器
const timer = ref<any>();

// 首次监听播放周刻度
let flag = true;

watch(type, (cur) => {
  flag = true;
  if (cur === 0) {
    pointChecked.value = true;
  }
  if (cur === 1) {
    pointChecked.value = true;
  }
  if (cur === 3) {
    // 清除站点图层

    // props.cesiumViewer.clearMarkMassEnvironments();

    pointChecked.value = true;
  }
  if (cur !== 0 || cur !== 1) {
    // 清除站点图层
    if (props.cesiumViewer && Object.keys(props.cesiumViewer).length && props.cesiumViewer.clearMarkMassEnvironments) {
      props.cesiumViewer.clearMarkMassEnvironments();
    }
  }
});
// 设置播放指针当前期次
const tipFormatter = (time: string) => `
${moment(time, 'YYYYMMDDHHmm').format('MM-DD HH:mm')}
 `;

// 所有侧边产品存储
const productDatas3D = computed(() => store.state.layerConsole.productDatas3D);
const windyIssueDatas = computed(() => store.state.layerConsole.windyIssueDatas);
const indexName = computed(() => store.state.layerConsole.indexName);

// 图片四至
const extent = [
  72,
  17,
  136,
  55,
];

// 判断弹框是否关闭
const popupShow = ref<any>(false);
const weatherPopupShow = ref<any>(false);

// 刚加载时是否根据弹窗位置移动
const popupMove = ref<any>(true);

// 气象站点数据
const weatherStationList = computed(() => store.state.layerConsole.weatherStationList);
// 气象弹窗数据
const weatherPopupData = ref<any>({});
// 当前要素历史数据
const weatherHistoryData = ref<any>({});
// 天气
const weatherVow = ref<any>({});

// 环境弹窗数据
const popupData = ref<any>({});
// 当前要素历史数据
const historyData = ref<any>({});
//  环境站点天气
const weatherVo = ref<any>({});

// 环境站点时间轴联动数据
const envPointListForTimes = ref({});

// 判断时间轴当前时间是否为最新时间
const isLatestTime = ref<boolean>(false);

// 节流
const throttleFlag = ref(true);
// 设置播放初始化当前时刻current
const setCurrtent = (data: any) => {
  const tempCurrent = moment().format('YYYYMMDDHH00');
  const temp = data.length - 1;

  current.value = temp === -1 ?
    0 :
    temp;
  isLatestTime.value = current.value === playMax.value;
};
// 风场展示
const windChecked = ref(false);
const windyData = computed(() => store.state.layerConsole.windyData);
// 设置播放轴刻度
const formateTime = (data: any) => {
  data.forEach((item: any, index: any) => {
    const tempTime = moment(item, 'YYYYMMDDHHmm').format('HH');

    let temp: any = '';

    if (type.value === 0) {
      if (tempTime === '09') {
        temp = {
          label: createVNode(
            'span',
            {
              class: 'time-formate',
            },
            [
              moment(item, 'YYYYMMDDHHmm').format('HH'),
              createVNode(
                'div',
                {
                  class: 'time-week',
                },
                `周${timeConvert(moment(item, 'YYYYMMDDHHmm').format('E'))}
              ${moment(item, 'YYYYMMDDHHmm').format('MM月DD日')}
              `
              ),
            ]
          ),
        };
      } else {
        temp = {
          label: createVNode(
            'span',
            {
              class: 'time-formate',
            },
            moment(item, 'YYYYMMDDHHmm').format('HH')
          ),
        };
      }
    } else if (index % 3 === 0 && tempTime === '00') {
      temp = {
        label: createVNode(
          'span',
          {
            class: 'time-formate',
          },
          [
            moment(item, 'YYYYMMDDHHmm').format('HH'),
            createVNode(
              'div',
              {
                class: 'time-week',
              },
              `周${timeConvert(moment(item, 'YYYYMMDDHHmm').format('E'))}
              ${moment(item, 'YYYYMMDDHHmm').format('MM月DD日')}
              `
            ),
          ]
        ),
      };
    } else if (index % 3 === 0) {
      temp = {
        label: createVNode(
          'span',
          {
            class: 'time-formate',
          },
          moment(item, 'YYYYMMDDHHmm').format('HH')
        ),
      };
    }

    marks.value[index] = temp;
  });
};

watch(playTime, (cur) => {
  if (Object.keys(cur).length && flag) {
    flag = false;
    playMin.value = 0;
    playMax.value = cur.length - 1;
    formateTime(cur);
    setCurrtent(cur);
  }
});

const changeVisable = () => {
  popupShow.value = false;
  weatherPopupShow.value = false;
};

// 判断最新播放时间没有数据，选择播放数据中最近批次数据,最多推三个小时
const getLatestValidData = (data: any, reportTime: string, timeType:'HH'|'mm' = 'HH'): any => {
  for (let i = 1; i <= 4; i++) {
    let retime = moment(moment(reportTime, 'YYYYMMDDHHmm')).subtract(i, 'hours').format('YYYYMMDDHH');

    if (timeType === 'mm') {
      retime = moment(moment(reportTime, 'YYYYMMDDHHmm')).subtract(i, 'hours').format('YYYYMMDDHHmm');
    }

    if (data[retime]) {
      return {
        key: retime,
        value: data[retime],
      };
    }
  }

  return null;
};

// 监听右侧导航栏产品要素数据
watch(productDatas3D,(cur) => {
  popupShow.value = false;
  weatherPopupShow.value = false;
  if (Object.keys(cur).length) {
    if (windyIssueDatas.value[playTime.value[current.value]]) {
      store.dispatch(
        'layerConsole/getWindyData',
        windyIssueDatas.value[playTime.value[current.value]]
      );
    }

    if (cur[playTime.value[current.value]]) {
      if (type.value === 0 || type.value === 1) {
        props.cesiumViewer.addPicLayer(
          cur,
          extent,
          playTime.value[current.value]
        );
      } else if (type.value === 2) {
        props.cesiumViewer.addLaDarLayer(
          cur,
          playTime.value[current.value]
        );
      } else if (type.value === 3) {
        props.cesiumViewer.addWeatherLayer(
          cur,
          extent,
          playTime.value[current.value]
        );
      }
    } else if (isLatestTime.value && (type.value === 0 || type.value === 1)) {
      const tmptime = playTime.value[current.value] ?? playTime.value[playTime.value.length - 1];
      const latestData = getLatestValidData(cur, tmptime,'mm');

      const { key, } = latestData || {};

      if (key) {
        props.cesiumViewer.addPicLayer(
          cur,
          extent,
          key
        );
      }
    }
  }
});

// 站点显隐定义在前面

watch(pointChecked, (cur) => {
  if (!cur) {
    // props.AMapView.labelsLayer.hide();
    props.cesiumViewer.hideMarkMassEnvironments();
  }
  if (cur) {
    // props.AMapView.labelsLayer.show();
    props.cesiumViewer.showMarkMassEnvironments();
  }
});

/*
 * 监听元素切换,不能写到下面，写到下面会导致站点显示不出来
 * watch(indexName, () => {
 *   if (props.cesiumViewer && Object.keys(props.cesiumViewer).length && props.cesiumViewer.clearMarkMassEnvironments) {
 *     props.cesiumViewer.clearMarkMassEnvironments();
 *   }
 * });
 */

// 监听气象站点数据
watch([weatherStationList,indexName,], ([curProductDatas, curName,], [oldProductDatas, coldName,]) => {
  if (
    Object.keys(props.cesiumViewer).length &&
      type.value === 3 &&
      props.cesiumViewer.markMassEnvironments
  ) {
    if (curProductDatas && Object.keys(curProductDatas).length) {
    // longitud => lon,latitude => lat
      const weatherPoints = curProductDatas.map((item:any) => ({ ...item, lon: item.longitude, lat: item.latitude, }));

      props.cesiumViewer.markMassEnvironments(weatherPoints,curName,(data: any) => {
        weatherPopupData.value = data;

        const params = qs.stringify({
          startIssue: moment().add(-3,'days').format('YYYYMMDD00'),
          endIssue: moment().format('YYYYMMDDHH'),
          stationId: data.stationId || data.gid,
        });

        store.dispatch('layerConsole/getWeatherInfoDetailsForAir', {
          params,
          callback: (data2: any) => {
          // 空气质量历史数据
            weatherHistoryData.value = data2.data;
            // 当前气象
            weatherVow.value = data2.weatherVo;

            weatherPopupShow.value = true;
            popupMove.value = true;
          },
        });
      },(position: any) => {
        const dom = document.getElementById('weather-popup');

        if (position) {
          if (dom) {
            dom.style.position = 'absolute';
            dom.style.left = `${position.x + 10}px`;
            dom.style.top = `${position.y + 10}px`;

            // 根据弹窗位置移动地球
            if (popupMove.value) {
              const exceedX = (dom.offsetWidth || 310) - (document.body.offsetWidth - position.x - 10);
              const exceedY = (dom.offsetHeight || 310) - (document.body.offsetHeight - position.y - 10);
              const toPosition = { x: position.x, y: position.y, };
              const angle = props.cesiumViewer.camera.positionCartographic.height / 23000000;

              setTimeout(() => {
                popupMove.value = false;
              },1000);

              if (exceedX >= 0) {
                toPosition.x = document.body.offsetWidth - dom.offsetWidth - 10;
                props.cesiumViewer.camera.rotateRight(0.01 * angle);
              }
              if (exceedY >= 0) {
                toPosition.y = document.body.offsetHeight - dom.offsetHeight - 10;
                props.cesiumViewer.camera.rotateUp(0.01 * angle);
              }
            }
          }
        }
      });
    } else {
      props.cesiumViewer.clearMarkMassEnvironments();
    }
  }
});

// 环境站点数据
const environmentStationList = computed(() => store.state.layerConsole.environmentStationList);

// 监听环境站点数据
watch([environmentStationList,indexName,],([curStationList,curName,]) => {
  if (
    Object.keys(props.cesiumViewer).length &&
      (type.value === 1 || type.value === 0) &&
      props.cesiumViewer.markMassEnvironments
  ) {
    if (curName && curStationList && Object.keys(curStationList).length) {
      props.cesiumViewer.markMassEnvironments(curStationList,curName,(data: any) => {
        popupData.value = data;

        // 站点弹窗随时间轴变化
        const endTime = moment(playTime.value[current.value],'YYYYMMDDHHmm').format('YYYYMMDDHH');
        const params = {
          pointGid: data.id,
          endTime,
          startTime: moment(playTime.value[current.value],'YYYYMMDDHHmm').add(-3, 'days').format('YYYYMMDDHH'),
        };

        /*
         * const params = {
         *   pointGid: data.pointGid,
         *   endTime: moment().format('YYYYMMDDHH'),
         *   startTime: moment().add(-3,'days').format('YYYYMMDDHH'),
         *   regionId: data.id,
         * };
         */

        store.dispatch('layerConsole/getEnvironmentStationInfo', {
          params,
          callback: (data2: any) => {
          // 弹窗的上半截（详情）
            [popupData.value,] = data2.airHistory.filter((item: any) => item.reportTime === endTime);
            // 空气质量历史数据
            historyData.value = data2.airHistory;
            // 当前气象
            weatherVo.value = data2.weatherVo;

            popupShow.value = true;
            popupMove.value = true;
          },
        });
      },(position: any) => {
        const dom = document.getElementById('popup');

        if (position) {
          if (dom) {
            dom.style.position = 'absolute';
            dom.style.left = `${position.x + 10}px`;
            dom.style.top = `${position.y + 10}px`;

            // 根据弹窗位置移动地球
            if (popupMove.value) {
              const exceedX = (dom.offsetWidth || 500) - (document.body.offsetWidth - position.x - 10);
              const exceedY = (dom.offsetHeight || 500) - (document.body.offsetHeight - position.y - 10);
              const toPosition = { x: position.x, y: position.y, };
              const angle = props.cesiumViewer.camera.positionCartographic.height / 23000000;

              setTimeout(() => {
                popupMove.value = false;
              },1000);

              if (exceedX >= 0) {
                toPosition.x = document.body.offsetWidth - dom.offsetWidth - 10;
                props.cesiumViewer.camera.rotateRight(0.01 * angle);
              }
              if (exceedY >= 0) {
                toPosition.y = document.body.offsetHeight - dom.offsetHeight - 10;
                props.cesiumViewer.camera.rotateUp(0.01 * angle);
              }
            }
          }
        }
      });
    } else {
      props.cesiumViewer.clearMarkMassEnvironments();
    }

    if (!pointChecked.value) {
      props.cesiumViewer.hideMarkMassEnvironments();
    }
  }
});

// 默认当前期次风场
const initWindy = () => {
  const currentTime = moment().format('YYYYMMDDHH');
  const param = {
    startTime: currentTime,
    endTime: currentTime,
  };
  const params = {
    param,
    type: '',
  };

  store.dispatch('layerConsole/getCurrentTimeWindy', params);
};

watch([windyData, windChecked,], ([curWindyData, curWindChecked,]) => {
  if (!curWindChecked && props.cesiumViewer.removeWindy) {
    props.cesiumViewer.removeWindy();

    return;
  }

  if (Object.keys(curWindyData).length && Object.keys(props.cesiumViewer).length && props.cesiumViewer.addWindy) {
    props.cesiumViewer.addWindy(curWindyData);
  }
});

// 设置播放图片标题
const setPlayTitle = () => {
  const temp = moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('YYYY年MM月DD日HH时');

  if (type.value === 0 || type.value === 1 || type.value === 3) {
    return `${temp}&nbsp;${factorKey[indexName.value]}分布图`;
  }

  if (type.value === 2) {
    return `${temp}&nbsp;雷达分布图`;
  }
};

// 站点历史数据

// const stationDatasForTimes = computed(() => store.state.layerConsole.stationDatasForTimes);

/**
 * 加载插值图的路径
 * @returns {void}
 */
const loadPicData = () => {
  const params = {
    startTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('YYYYMMDDHHmm'),
    endTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').add(1, 'hour').format('YYYYMMDDHHmm'),
    indexName: indexName.value,
    // 数据来源
    type: type.value,
    // 地球纬度
    queryType: 1,
  };

  store.dispatch('layerConsole/getHistoryData', params);
};

/**
 * 环境站点和时间轴联动列表接口请求
 * @param {any} params 开始结束时间入参
 * @returns {void}
 */
const loadStationData = (params: any) => {
  if (throttleFlag.value) {
    throttleFlag.value = false;
    store.dispatch('layerConsole/getEnvDatasForTimes', {
      params,
      callback: (val:any) => {
        envPointListForTimes.value = {};
        // envPointListForTimes.value = { ...envPointListForTimes.value, ...val, };
        envPointListForTimes.value = val;
      },
    });
  } else {
    setTimeout(() => {
      throttleFlag.value = true;
    }, 500);
  }
};

/**
 * 环境站点和时间轴联动列表接口请求
 * @returns {void}
 */

const handleCurrent = (key: any): void => {
  isLatestTime.value = key === playMax.value;
  const currentTime = playTime.value[key];

  popupShow.value = false;
  weatherPopupShow.value = false;

  // 添加风场
  if (windyIssueDatas.value[currentTime] && windChecked.value) {
    store.dispatch('layerConsole/getWindyData', windyIssueDatas.value[currentTime]);
  } else {
    props.cesiumViewer.removeWindy();
  }
  props.cesiumViewer.changeOpacity(currentTime);

  const curH = moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('HH');

  const isGetData = curH === '12' || curH === '00';

  // if (isGetData) {
  loadPicData();

  //  卫星/站点图层叠加到地图上
  if (type.value === 0 || type.value === 1) {
    props.cesiumViewer.addPicLayer(
      productDatas3D.value,
      extent,
      playTime.value[current.value]
    );
  } else if (type.value === 2) {
    props.cesiumViewer.addLaDarLayer(
      productDatas3D.value,
      playTime.value[current.value]
    );
  } else if (type.value === 3) {
    props.cesiumViewer.addWeatherLayer(
      productDatas3D.value,
      extent,
      playTime.value[current.value]
    );
  }
  // }

  if (productDatas3D.value[playTime.value[current.value]]) {
    if (type.value === 0 || type.value === 1) {
      props.cesiumViewer.switchPicLayer(
        productDatas3D.value,
        playTime.value[current.value]
      );
    } else if (type.value === 2) {
      props.cesiumViewer.switchLaDarLayer(
        productDatas3D.value,
        playTime.value[current.value]
      );
    } else if (type.value === 3) {
      props.cesiumViewer.switchWeatherLayer(
        productDatas3D.value,
        playTime.value[current.value]
      );
    }
  }

  // 站点值随时间轴联动
  if (type.value === 0 || type.value === 1 || type.value === 3) {
    const stationData = envPointListForTimes.value[playTime.value[current.value]?.replace('00', '')] ||
      envPointListForTimes.value[Object.keys(envPointListForTimes.value)[0]]?.map((ele: any) => {
        let result = ele;

        // if (isGetData) {
        const stationParams = {
          startTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('YYYYMMDDHH'),
          endTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').add(1, 'hour').format('YYYYMMDDHH'),
        };

        loadStationData(stationParams);
        //  }

        if (type.value === 3) {
          result = {
            gid: ele.gid,
            lat: ele.lat,
            lon: ele.lon,
            name: ele.name,
            province: ele.province,
            pre: '999999',
            prs: '999999',
            rhu: '999999',
            tem: '999999',
            windD: '999999',
            windS: '999999',
          };
        } else {
          result = ele;
        }

        return result;
      });

    // props.AMapView.setMassMarkersText(stationDatasForTimes.value[playTime.value[current.value]], indexName.value);
    if (stationData) {
      props.cesiumViewer.markMassEnvironments(stationData,indexName.value,(data: any) => {
        let params;

        if (type.value === 1 || type.value === 0) {
          popupData.value = data;

          // 站点弹窗随时间轴变化
          const endTime = moment(playTime.value[current.value],'YYYYMMDDHHmm').format('YYYYMMDDHH');

          params = {
            pointGid: data.id,
            endTime,
            startTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').add(-3, 'days').format('YYYYMMDDHH'),
            // regionId: data.id,
          };

          /*
           * params = {
           *   pointGid: data.pointGid,
           *   startTime: moment().add(-3,'days').format('YYYYMMDD00'),
           *   endTime: moment().format('YYYYMMDDHH'),
           *   regionId: data.id,
           * };
           */

          store.dispatch('layerConsole/getEnvironmentStationInfo', {
            params,
            callback: (data2: any) => {
              // 弹窗的上半截（详情）
              [popupData.value,] = data2.airHistory.filter((item: any) => item.reportTime === endTime);
              // 空气质量历史数据
              historyData.value = data2.airHistory;
              // 当前气象
              weatherVo.value = data2.weatherVo;

              popupShow.value = true;
              popupMove.value = true;
            },
          });
        } else if (type.value === 3) {
          weatherStationList.value.forEach((item: any) => {
            if (item.stationId === data.gid) {
              weatherPopupData.value = item;
            }
          });

          params = qs.stringify({
            startIssue: moment().add(-3,'days').format('YYYYMMDD00'),
            endIssue: moment().format('YYYYMMDDHH'),
            stationId: data.stationId || data.gid,
          });

          store.dispatch('layerConsole/getWeatherInfoDetailsForAir', {
            params,
            callback: (data2: any) => {
            // 空气质量历史数据
              weatherHistoryData.value = data2.data;
              // 当前气象
              weatherVow.value = data2.weatherVo;

              weatherPopupShow.value = true;
              popupMove.value = true;
            },
          });
        }
      },(position: any) => {
        let dom;

        if (type.value === 1 || type.value === 0) {
          dom = document.getElementById('popup');
        }
        if (type.value === 3) {
          dom = document.getElementById('weather-popup');
        }

        if (position) {
          if (dom) {
            dom.style.position = 'absolute';
            dom.style.left = `${position.x + 10}px`;
            dom.style.top = `${position.y + 10}px`;

            // 根据弹窗位置移动地球
            if (popupMove.value) {
              const exceedX = (dom.offsetWidth || (type.value === 3 ?
                310 :
                500)) - (document.body.offsetWidth - position.x - 10);
              const exceedY = (dom.offsetHeight || (type.value === 3 ?
                310 :
                500)) - (document.body.offsetHeight - position.y - 10);
              const toPosition = { x: position.x, y: position.y, };
              const angle = props.cesiumViewer.camera.positionCartographic.height / 23000000;

              setTimeout(() => {
                popupMove.value = false;
              },1000);

              if (exceedX >= 0) {
                toPosition.x = document.body.offsetWidth - dom.offsetWidth - 10;
                props.cesiumViewer.camera.rotateRight(0.01 * angle);
              }
              if (exceedY >= 0) {
                toPosition.y = document.body.offsetHeight - dom.offsetHeight - 10;
                props.cesiumViewer.camera.rotateUp(0.01 * angle);
              }
            }
          }
        }
      });
    }
  } else {
    props.cesiumViewer.clearMarkMassEnvironments();
  }

  const str = moment().subtract(3, 'day').add(1, 'hour').format('YYYYMMDD0000');
};

/**
 *  停止播放
 * @returns {void}
 */
const stopPlay = (): void => {
  clearInterval(timer.value);
  timer.value = null;
};

/**
 * 开始播放
 * @returns {void}
 */
const startPlay = (): void => {
  const stationParams = {
    startTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('YYYYMMDDHH'),
    endTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').add(1, 'hour').format('YYYYMMDDHH'),
  };

  loadStationData(stationParams);

  timer.value = setInterval(() => {
    const tempCurrent = moment(playTime.value[current.value], 'YYYYMMDDHHmm').valueOf();
    const tempTime = moment(moment(playTime.value[playTime.value.length - 1], 'YYYYMMDDHHmm').format('YYYYMMDDHH00'), 'YYYYMMDDHHmm').valueOf();
    const tempMax = moment(playTime.value[playMax.value], 'YYYYMMDDHHmm').valueOf();

    // 若为卫星、站点、雷达为历史数据
    if (tempCurrent >= tempTime && type.value !== 3) {
      current.value = 0;

    // 气象数据是预报数据
    } else if (tempCurrent >= tempMax && type.value === 3) {
      current.value = 0;
    }

    handleCurrent(current.value);
    current.value += 1;
  }, 5000);
};

/**
 * 滑动滑条
 * @param {any} value 当前的下标
 * @returns {void}
 */
const handleSliderChange = (value: any): void => {
  current.value = value;

  loadPicData();

  const stationParams = {
    startTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').format('YYYYMMDDHH'),
    endTime: moment(playTime.value[current.value], 'YYYYMMDDHHmm').add(1, 'hour').format('YYYYMMDDHH'),
  };

  loadStationData(stationParams);

  handleCurrent(current.value);
};

/**
 * 更改播放状态
 * @returns {void}
 */
const handlePlayer = (): void => {
  isPlay.value = !isPlay.value;

  if (!isPlay.value) {
    stopPlay();

    return;
  }

  startPlay();
};

// 监听元素切换
watch(indexName, (cur, old) => {
  if (cur) {
    playMin.value = 0;
    playMax.value = playTime.value.length - 1;
    // 设置时间轴刻度
    formateTime(playTime.value);
    setCurrtent(playTime.value);
    if (props.cesiumViewer.clearLayer) {
      props.cesiumViewer.clearLayer();
    }
    if (props.cesiumViewer.removeWindy) {
      props.cesiumViewer.removeWindy();
    }
    isPlay.value = false;
    stopPlay();
  }

  if (cur) {
    playShow.value = true;
    if (cur === 'RADAR') {
      pointCheckedShow.value = false;
      pointChecked.value = false;
    } else {
      pointCheckedShow.value = true;
      pointChecked.value = true;
    }
  } else {
    pointCheckedShow.value = false;
    isPlay.value = false;
    stopPlay();
    playShow.value = false;
    props.cesiumViewer.clearLayer();
    if (props.cesiumViewer.removeWindy) {
      props.cesiumViewer.removeWindy();
    }
    initWindy();
  }

  // props.cesiumViewer.clearMarkMassEnvironments();写到这里会导致站点无法显示
  popupShow.value = false;
  weatherPopupShow.value = false;

  if (cur === 'AOD') {
    pointChecked.value = false;
  }
});

onMounted(() => {

  /*
   * initWindy();
   * loadStationDatasForTimes();
   */
});

onBeforeUnmount(() => {
  props.cesiumViewer.removeWindy();
  props.cesiumViewer.clearLayer();
  store.commit('layerConsole/setHistoryData', {});
  store.commit('layerConsole/setProductData3D', {});
  store.commit('layerConsole/setWindyIssueData', {});
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "play-title",
      innerHTML: setPlayTitle()
    }, null, 8, _hoisted_1), [
      [_vShow, playShow.value && _unref(type) !== '2']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "play-btn",
        onClick: handlePlayer
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(`iconfont ${isPlay.value ? 'icon-24gf-pause2' :'icon-bofang'}`)
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Slider), {
          class: "currentTime",
          value: current.value,
          min: playMin.value,
          max: playMax.value,
          tooltipVisible: playShow.value && _unref(type) !== '2',
          tipFormatter: () => tipFormatter(_unref(playTime)[current.value]),
          tooltipPlacement: "leftTop",
          marks: marks.value,
          getTooltipPopupContainer: (triggerNode) => triggerNode.parentNode,
          onChange: handleSliderChange
        }, null, 8, ["value", "min", "max", "tooltipVisible", "tipFormatter", "marks", "getTooltipPopupContainer"])
      ])
    ], 512), [
      [_vShow, playShow.value && _unref(type) !== '2']
    ]),
    _createVNode(SideBar),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex", windChecked.value ? 'on' : 'off']),
        onClick: _cache[0] || (_cache[0] = ()=>{
    windChecked.value = !windChecked.value;
  })
      }, "风场", 2),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex", pointChecked.value ? 'on' : 'off']),
        onClick: _cache[1] || (_cache[1] = ()=>{
        pointChecked.value = !pointChecked.value;
      })
      }, "站点", 2), [
        [_vShow, pointCheckedShow.value && _unref(indexName) && _unref(indexName) !== 'AOD']
      ])
    ]),
    _withDirectives(_createVNode(Popup, {
      ref: "popupEle",
      onCancelPop: changeVisable,
      theme: "dark",
      popupData: popupData.value,
      historyData: historyData.value,
      weatherVo: weatherVo.value
    }, null, 8, ["popupData", "historyData", "weatherVo"]), [
      [_vShow, popupShow.value]
    ]),
    _withDirectives(_createVNode(weatherPopUp, {
      ref: "weatherPopupEle",
      onCancelPop: changeVisable,
      theme: "dark",
      weatherPopupData: weatherPopupData.value,
      weatherHistoryData: weatherHistoryData.value,
      weatherVow: weatherVow.value,
      time: _unref(playTime)[current.value]
    }, null, 8, ["weatherPopupData", "weatherHistoryData", "weatherVow", "time"]), [
      [_vShow, weatherPopupShow.value]
    ])
  ], 64))
}
}

})